import "antd/dist/reset.css";
import {  Collapse } from "antd";
import { Card,Descriptions} from "antd";
import React, { useState , useEffect} from 'react';
import utils from "utils";


const { Panel } = Collapse;
const MHELabel = {
  "presenting_problem": "History of Presenting Problems",

//PRE-MORBID CHECKLIST

"attitude" : "Attitude to self, Attitude to others [family, friends, relationships]",
"predominant_mood" : "Predominant mood",
"sensitivity":"Sensitivity",
"adaptability":"Adaptability",
"attention_concentration":"Attention/Concentration",
"motivation":"Motivation",
"activity":"Activity",
"aggression":"Aggression",

 //PERSONALITY TRAITS ('OCEAN')
"openness":"'O'penness",
"notes":"Notes",
"conscientiousness":"'C'onscientiousness",
"extraversion":"'E'xtraversion",
"agreebleness":"'A'greeableness",
"neuroticism":"'N'euroticism",
"attention_persistance" : "Attention, Persistence, Frustration Tolerance",

//EXAMINATION ('ASEPTIC')

//Appearance, Behaviour, Motor Activity
"appearance_values" : "Physical Appearance/Grooming",
"grooming" : "Grooming, Built",
"eye_contact" : "Eye contact",
"clinician_interaction" : "Interactions with Clinician",
"tics" : "Tics, Stereotypes, Mannerisms",
"tics_notes" : "Notes",
"psychomotor_activity" : "Psychomotor Activity",
"psychomotor_activity_notes" : "Notes",
"impulsivity" : "Impulsivity/Oppositionality/Aggression",
"impulsivity_notes" : "Notes",

//Speech
"volume" : "Volume",
"relevant" : "Relevant",
"coherent" : "Coherent",
"articulation" : "Articulation",

//Emotion
"mood_over_a_week" : "Mood",
"mood_over_a_week_notes" : "Notes",
"affect_right_now_subjective" : "Affect - Right now (At the time of evaluation)",
"affect_right_now_subjective" : "Subjective - What patient describes",
"right_mood_value" : "Mood",
"right_mood_notes" : "Notes",
"objective" : "Objective - What Clinician has inferred at the time of the interview?", // API
"objective_mood_value" : "Mood",
"objective_mood_notes" : "Notes",

//Perception
"hallucinations" : "Hallucinations",
"hallucinations_notes" : "Notes",

//Thought
"wishes_test" : "3 Wishes Test",
"my_home" : "My Home",
"stream" : "Stream",
"stream_notes" : "Notes",
"form" : "Form",
"form_notes" : "Notes",
"content" : "Content",
"content_notes" : "Notes",

//Insight
"awarness_illness" : "Awareness of illness",
"awarness_notes" : "Notes",
"attributing_mental_illness" : "Attributing it to mental illness",
"attributing_notes" : "Notes",
"acceptance_treatment" : "Acceptance to treatment",
"acceptance_notes" : "Notes",
"capacity_treatment" : "Capacity to choose a form of treatment",
"capacity_notes" : "Notes",
"consequences" : "Awareness of the consequences of refusing to take treatment",
"consequences_notes" : "Notes",

//Cognitive
"attention" : "Attention & Concentration",
"memory" : "Memory",
"intelligence" : "Clinical Estimate of Intelligence",
"comprehension" : "Comprehension",
"arithmetic_skills" : "Arithmetic skills - Enquire whether he/she has any difficulty in calculation",
"abstraction" : "Abstraction",
"judgement" : "Judgement and Insight",
"personal" : "Personal - What is your future plans? and What is your objective in Life?",
"social" : "Social - Respectful towards Clinician/Doctors",
"comments" : "Comments",
}
const MHESummaryNew = (props) => {
  const [activeTabKey1, setActiveTabKey1] = useState('tab1');
  const [tabListnew,setTabList]=useState([])
  useEffect(() => {
    Object.entries(props.data?.values||{}).forEach(([key,val])=>{
     
    })
  

    if (props.data.is_completed) {
    
    let temp=props.data?.values?.examination?.values
    let tempList=[]
    Object.entries(temp||{}).forEach(([key,val])=>{
      
if(key=="speech"){
Object.values(val.values).some((field)=>{
  if(field?.values){
    
   
  }

})}
if(key=="apprearance"){
  Object.values(val.values).some((field)=>{
    if(field.field_type=="radio_button"){
      Object.values(field.values).some(ele=>{
        if(ele.is_selected==true){
            if(!tabListnew.includes(key))
            // tabList1.push(key)
            setTabList([...tabListnew,key])
        }
      })
    }
    if(field.field_type=="text"){
      if(field?.values){
        if(!tabListnew.includes(key))
        // tabList1.push(key)
        setTabList([...tabListnew,key])
      }
    }
  })
}if(key=="perception"){
  Object.values(val.values).some((field)=>{
    if(field.field_type=="check_box"){
      Object.values(field.values).some(ele=>{
        if(ele.is_selected==true){
          if(!tabListnew.includes(key))
          // tabList1.push(key)
          setTabList([...tabListnew,key])
        }
      })
    }
    if(field.field_type=="text"){
      if(field?.values){
        if(!tabListnew.includes(key))
        // tabList1.push(key)
        setTabList([...tabListnew,key])
      }
    }
  })
}
if(key=="thought"){
  Object.values(val.values).some((field)=>{
    if(field.title){
      Object.values(field.values).map(child=>{
       
        if(child.field_type=="radio_button"){
          Object.values(child.values).some(ele=>{
            if(ele.is_selected==true){
              if(!tabListnew.includes(key))
              // tabList1.push(key)
              setTabList([...tabListnew,key])
            }
          })
        }
        if(child.field_type=="text"){
          if(child?.values){
            if(!tabListnew.includes(key))
            // tabList1.push(key)
            setTabList([...tabListnew,key])
          }
        }

      })
    }else if(
      field.label
    ){
      Object.values(val.values).some((field)=>{
        if(field?.values){
          if(!tabListnew.includes(key))
        // tabList1.push(key)
        setTabList([...tabListnew,key])
        }
      
      })
    }
  })
}
    })

    }
   
  }, [props.data]);


  const RecursiveSummary=(value)=>  

  {

    return(
      Object.entries(value || {}).map(([FormItemKey, FormItemData]) => 
      {if (FormItemData?.title=="Examination"){
        return(
          <Collapse onChange={onExaminationClicked}  expandIconPosition= "start" ghost = {true} className='mhe-list-container'>
        <Panel header={"EXAMINATION ('ASEPTIC')"} key="c">
        <Card
      style={{
        width: '100%',
      }}
      tabList={tabList.filter((element)=>{{return element}})}
      activeTabKey={activeTabKey1}
      onTabChange={(key,FormItemData) => {
        onChange(key)
      }}
    >
      {contentList("tab1",FormItemData)}
    </Card>
        </Panel>
        </Collapse>
        )
      }
         else


              if(FormItemData?.title){ 
              return(
            <>
          
                <Collapse expandIconPosition= "start" ghost = {true} className='mhe-list-container'>
              
                <Panel header={FormItemData?.title}>
               
                  {RecursiveSummary(FormItemData.values)}
                  </Panel>
                  </Collapse>
                  </>
              )
              }   

              else
          
               if(typeof FormItemData?.values == "string" && FormItemData?.field_type=="text"){
                return(
                  <div>
                       
                              <Descriptions
                               bordered
                               size="middle"
                               contentStyle={{width:"40%"}}
                               labelStyle={{width:"50%"}}>
                                {FormItemData.values.length>0?
                              <Descriptions.Item label={FormItemData.label}>{FormItemData.values}</Descriptions.Item>:null}
                              </Descriptions>
                             
                  </div>
                  
              ) 
               }
               if(Array.isArray(FormItemData?.values)&&FormItemData?.label )
            
              {
                if(FormItemData.field_type=="radio_button"){
                 
                  return(
                    
                      <div>
                    
                            {FormItemData.values.map((selected)=>{
                            
                           if( selected.is_selected) return(
                                  <>
                                 
                                
                                  <Descriptions
                                   bordered
                                   size="middle"
                                   contentStyle={{width:"40%"}}
                                   labelStyle={{width:"50%"}}>
                                  <Descriptions.Item label={FormItemData.label}>{selected.label}</Descriptions.Item>
                                  </Descriptions>
                                  </>
                           )
                          })}
                      </div>
                      
                  )}
                  else 
                  if(FormItemData.field_type=="check_box" && FormItemData.label !=="User Type"){
                  {  let show=FormItemData.values.map((selected)=>selected.is_selected)
                    if(show.includes(true)){
                      return(
                        <>
                       
                         
                         <div>                           
                                     <Descriptions
                                      bordered
                                      size="middle"
                                      contentStyle={{width:"40%"}}
                                      labelStyle={{width:"50%"}}>
                                     <Descriptions.Item  label={FormItemData.label}>
                                    { FormItemData?.values.map((selected,index)=>{
                                    if(selected.is_selected)
                                    return(
                                      selected?.is_selected?.length > 1 ?<ul><li>{selected.label}</li></ul> : <div>{selected.label}</div>
                                    )
                                  })}
                                     </Descriptions.Item>
                                     </Descriptions>
                                    
                        
                         </div>
                         </>
                     )
                    }
                  }
                    // if(show.includes(true))
                  
                  }else if(FormItemData.field_type=="text"){
                   
                    if(FormItemData?.values?.length>0)
                    return(
                      <div>
                           
                                  <Descriptions
                                   bordered
                                   size="middle"
                                   contentStyle={{width:"40%"}}
                                   labelStyle={{width:"50%"}}>
                                    {FormItemData.values.length>0?
                                  <Descriptions.Item label={FormItemData.label}>{FormItemData.values}</Descriptions.Item>:null}
                                  </Descriptions>
                                 
                      </div>
                      
                  ) 
                  }
              }     

      })
      )
  }
  const onExaminationClicked=()=>{
    setActiveTabKey1("tab1")
  }
  const onChange = (key) => {
    setActiveTabKey1(key)    
  };
  const tabList = [
    {
      key: 'tab1',
      tab: 'A',
    },
    {
      key: 'tab2',
      tab: 'S',
    },
    {
      key: 'tab3',
      tab: 'E',
    },
    {
      key: 'tab4',
      tab: 'P',
    },
    {
      key: 'tab5',
      tab: 'T',
    },
    {
      key: 'tab6',
      tab: 'I',
    },
    {
      key: 'tab7',
      tab: 'C',
    },
  ];


  const contentList =(label,val)=>{
   
   if(activeTabKey1=="tab1"){
  
    return(
      <ASPECsummary value ={ val.values.apprearance.values|| {}} />
    )}
    if(activeTabKey1=="tab2"){
      return(
        <ASPECsummary value ={ val.values.speech.values|| {}} />
      )
    
   }if(activeTabKey1=="tab3"){
    return(
      <ASPECsummary value ={ val.values.emotion.values|| {}} />
    )
    
   }
   if(activeTabKey1=="tab4"){
    return(
      <ASPECsummary value ={ val.values.perception.values|| {}} />
    )
    
   }
   if(activeTabKey1=="tab5"){
    return(
      <ASPECsummary value ={ val.values.thought.values|| {}} />
    )
    
   }
   if (activeTabKey1 == "tab6") {
    return <ASPECsummary value={val.values.insight.values || {}} />;
  }
   if(activeTabKey1=="tab7"){
    return(
      <ASPECsummary value ={ val.values.cognition.values|| {}} />
    )
    
   }
   }
   const textFields=(data)=>{
    if(data.label && data.field_type=="text" && data?.values?.length>0)
        {
          return(
            <Descriptions
            bordered
            size="middle"
            contentStyle={{width:"40%"}}
            labelStyle={{width:"50%"}}>
              <Descriptions.Item label={data.label}>    
              {data.values}         
              </Descriptions.Item>
            </Descriptions>
          )
        }
   }
   const loopRadioButtonSummary=(data)=>{
   
    return(
      data.values.map((selected)=>{   
        if(selected.is_selected)
        {
          return(
                 <Descriptions
                    bordered
                    size="middle"
                    contentStyle={{width:"40%"}}
                    labelStyle={{width:"50%"}}>
                   <Descriptions.Item label={data.label}>{selected.label}</Descriptions.Item>
                   </Descriptions>
          )
        }      
      })
    )
    
   }
   const loopCheckBox=(data)=>{ 
      let selectedChecks = [];
       data.values.map((checks)=>{
          if(checks.is_selected)
          {
            selectedChecks.push(checks.label)
          }
        })        
        if(selectedChecks.length>0)
        {
          return(
            <Descriptions
            bordered
            size="middle"
            contentStyle={{width:"40%"}}
            labelStyle={{width:"50%"}}>
              <Descriptions.Item label={data.label}>    
              {selectedChecks.map((data)=>{
               return(selectedChecks.length>1 ?<ul><li>{data}</li></ul> : <div>{data}</div>)
              })}          
              </Descriptions.Item>
            </Descriptions>
          )
        }
        
   }
   const LoopNotes=(data)=>{
    return(
      <Descriptions
      bordered
      size="middle"
      contentStyle={{width:"40%"}}
      labelStyle={{width:"50%"}}>
        <Descriptions.Item label={data.label}>    
        {data.values}         
        </Descriptions.Item>
      </Descriptions>
    )
   }
  const onTab1Change = (key) => {
    setActiveTabKey1(key);
  };
const  ASPECsummary=(val,col)=>{
    if(activeTabKey1=="tab1"|| activeTabKey1=="tab2")return(
      Object.values(val.value).map((item,index)=>{ 
          if(item.field_type=="radio_button"){
          
            return(<>{loopRadioButtonSummary(item) }</>)              
          }
          if(item.field_type=="text"){
           if(item?.values?.length>0) return(
              <Descriptions
                  bordered
                  size="middle"
                  contentStyle={{width:"40%"}}
                  labelStyle={{width:"50%"}}>
                 <Descriptions.Item label={item.label}>{item.values}</Descriptions.Item>
                 </Descriptions>
            )
          }
      })
    )
    if(activeTabKey1 =="tab3"){
      return(
     Object.values(val.value).map((label,index)=>{
      if(label.title){
        return(
      Object.values(label.values).map((child,index)=>{
        if(child.field_type=="radio_button"){

          return(<>{loopRadioButtonSummary(child)}</>)
        }
        if(child?.field_type=="text" && child?.values?.length>0){
          return(
        <Descriptions bordered
        size="middle"
        contentStyle={{width:"40%"}}
        labelStyle={{width:"50%"}}>
          <Descriptions.Item label={child.label}>            
               {child?.values}             
          </Descriptions.Item>
        </Descriptions>
        )
        }
      }))
}
      if(label.label && label.field_type=="check_box")
      { 
        return(<>{loopCheckBox(label) }</>)  
      }
      if(label.label && label.field_type=="text" && label?.values?.length>0)
      {
        let notes = label.values;       
        if(notes)
        {
          return(
            <Descriptions
            bordered
            size="middle"
            contentStyle={{width:"40%"}}
            labelStyle={{width:"50%"}}>
              <Descriptions.Item label={label.label}>    
               {notes}         
              </Descriptions.Item>
            </Descriptions>
          )
        }      
        
      }
     }))
    }
    if(activeTabKey1=="tab4"){
      return(
      Object.values(val.value).map(field=>{
        if(field.field_type=="check_box"){
          return(
           <> {loopCheckBox(field)}</>
          )
        }
        if(field.field_type=="text"){
          return(
            <>{textFields(field)}</>
          )
        }
      }))
    }
    if(activeTabKey1=="tab5"){
      return(
      Object.values(val.value).map((item,index)=>{
        if(item.title || typeof item.values=="object"){
          return(
          Object.values(item.values).map((child,index)=>{
            if(child.field_type=="check_box"){
              return(<>{loopCheckBox(child)}</>
            )
            }
            if(child.field_type=="text")
            {
              return(<>{textFields(child)}</>)
            }
          }))
        }
        
        if(item.label && item.field_type=="text" && item?.values?.length>0)
        {
          return(<>{LoopNotes(item)}</>)
        }
      })
      )
    }
    if(activeTabKey1=="tab6"){
      return Object.values(val.value).map((item, index) => {
        if (item.title) {
          return Object.values(item.values).map((child, index) => {
            if (child.field_type == "radio_button") {
            
              return (
           <>{loopRadioButtonSummary(child)}</>
              );
            }
            if(child.field_type == "text"){
              
              if(child?.values?.length>0)return (
                <Descriptions
                  bordered
                  size="middle"
                  contentStyle={{ width: "40%" }}
                  labelStyle={{ width: "50%" }}
                >
                  <Descriptions.Item label={child.label}>   
                            {child?.values?.length>0 ?<li>{child.values}</li>: <div>{child.values}</div>}
                  </Descriptions.Item>
                </Descriptions>
              );
            }
          });
        }
        if(item.label && item.field_type=="text" && item?.values?.length>0)
        {
          return(<>{LoopNotes(item)}</>)
        }
      });
    }
    if(activeTabKey1=="tab7"){
      return(
      Object.values(val.value).map((label,index)=>{
        if(label.title == "Clinician Doctors"){
          let comments_value = label?.values?.comments?.values || "";
          let componentArray = []
          if(label?.values?.clinician_doctors?.field_type=="radio_button"){      
            componentArray.push (<>{ loopRadioButtonSummary(label.values.clinician_doctors)}</>)          
          }
          if(label?.values?.comments?.label== "Comments" && comments_value && comments_value?.length>0 ) {
            componentArray.push (
            <Descriptions
            bordered
            size="middle"
            contentStyle={{width:"40%"}}
            labelStyle={{width:"50%"}}>
              <Descriptions.Item label={label?.values?.comments?.label}>    
               {comments_value}         
              </Descriptions.Item>
            </Descriptions>
          )
          }
          if(componentArray.length > 0){
            return (<>{componentArray.map((component, index) => (
              <React.Fragment key={index}>{component}</React.Fragment>
            ))}</>)
          }
        }
        if(label.label && label.field_type=="radio_button"){
      
         return(<>{ loopRadioButtonSummary(label)}</>)          
        }
        if(label?.label && label?.field_type=="text" && label?.values?.length>0)
      {
          return(
            <Descriptions
            bordered
            size="middle"
            contentStyle={{width:"40%"}}
            labelStyle={{width:"50%"}}>
              <Descriptions.Item label={label.label}>    
               {label.values}         
              </Descriptions.Item>
            </Descriptions>
          )     
      }
      })
      )
    }
   
  }

{}
  return (
    <>
  {props.data?.completion_date ? 
    <Collapse style={{ overflowY:"auto"}} onChange={onChange} bordered={false} expandIconPosition= "start" ghost = {true} className='mhe-list-container'>       
                                    <Panel
                                   header={
                                    <div>
                                        {utils.FormatDate(props.data?.completion_date, "DATE_14")},{" "}
                                        {utils.FormatDate(props.data?.completion_date, "TIME_1")}{"  "}
                                    </div>
                                    }
                                    extra={utils.FirstNameLastName(utils.salutationPrefixName(props.data.doctor_salutation,utils.getDisplayName(props.data.consultation_doctor, props.data.doctor_last_name)), "250px")}
                                   style={{marginTop:"0px"}}      
                                >
                                   {RecursiveSummary(props?.data.values)}       
                                </Panel>                               
    </Collapse>
: null}
    </>
  );
};

const checkIsSelected=(val)=>{
  val.map(option=>{

  })
}



const summaryConverter = (val) => {
  let result = MHELabel[val.trim()] ? MHELabel[val.trim()] : utils.ConvertToPascalCase(val);
  return result;
}

export default MHESummaryNew;